export const ISetCookieSettingsUseCaseType = Symbol('ISetCookieSettingsUseCase');
